import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ReportIcon from '@mui/icons-material/AssessmentOutlined';
import DonutSmallOutlinedIcon from '@mui/icons-material/DonutSmallOutlined';
import GridViewIcon from '@mui/icons-material/GridView';
import HistoryIcon from '@mui/icons-material/History';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import ViewCompactAltOutlinedIcon from '@mui/icons-material/ViewCompactAltOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import VpnLockIcon from '@mui/icons-material/VpnLockOutlined';
import { ReactComponent as PartnerIcon } from '../../assetts/images/Partner.svg';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';

export const partnerDashboardMenu = (permissionConfig, userType, partnerCustomer, userPermissions) => {


  return [
    // `${userType === 2 || userType === 3 ? '/partner-dashboard' : '/dashboard'}`
    {
      id: 0, text: 'Partner Dashboard', path: '/partner-dashboard', icon: <DashboardCustomizeOutlinedIcon />, permission: "dashboard-read", visibility: true, type: 'partner-view',
      children: [
        {
          id: 1.1, text: 'Dashboard', path: '/partner-dashboard', icon: <DashboardOutlinedIcon />, permission: "dashboard-read", visibility: permissionConfig?.dashboard.read, type: 'partner-view'
        },
        {
          id: 1.2, text: 'User Management', path: '/user-management', icon: <PeopleOutlinedIcon />, permission: "dashboard-read", visibility: permissionConfig?.customer?.create &&
            [
              ...Object.values(permissionConfig?.partner || {}),
              ...Object.values(permissionConfig?.customer || {}),
              ...Object.values(permissionConfig?.user || {})
            ].some(Boolean), type: 'partner-view',
          children: [
            //     {
            //       id: 1.11,
            //       text: 'Partner',
            //       path: '/user-management/partner',
            //       icon: <PartnerIcon width="22px" height="22px" />,
            //       permission: "partner-read",
            //       visibility: permissionConfig?.partner.create || permissionConfig?.partner.read || permissionConfig?.partner.update,
            //  type: 'partner-view'

            //     },
            {
              id: 1.12,
              text: 'Customer',
              path: '/user-management/customer',
              icon: <HeadsetMicOutlinedIcon width="22px" height="22px" />,
              permission: "customer-read",
              visibility: permissionConfig?.customer.create || permissionConfig?.customer.read || permissionConfig?.customer.update,
              type: 'partner-view'

            },
            {
              id: 1.13,
              text: 'Partner Users',
              path: '/user-management/users',
              icon: <GroupOutlinedIcon width="22px" height="22px" />,
              permission: "user-read",
              visibility: permissionConfig?.user.create || permissionConfig?.user.read || permissionConfig?.user.update,
              type: 'partner-view'

            }
          ],
        },
        {
          id: 1.4, text: 'Logs', path: '/logs', icon: <BusinessCenterOutlinedIcon />, permission: '', visibility: userPermissions?.includes('customer_workflow-update'), type: 'partner-view'
        },
        {
          id: 1.7, text: 'Profile', path: '/profile', icon: <Person2OutlinedIcon />, permission: '', visibility: userPermissions?.includes('user-detail-read'), type: 'partner-view'
        },
        {
          id: 1.8, text: 'Inbox', path: '/inbox', icon: <InboxOutlinedIcon />, permission: '', visibility: true, type: 'partner-view'
        },
        // {
        //   id: 1.9, text: 'Settings', path: '/settings', icon: <SettingsOutlinedIcon />, permission: '', visibility: true, type: 'partner-view'
        // },
      ]
    },
    {
      id: 2, text: `${partnerCustomer.name}`, path: '/dashboard', icon: <ManageAccountsOutlinedIcon width="22px" height="22px" />, permission: "dashboard-read", visibility: !!partnerCustomer.customerId || !!partnerCustomer.name, type: 'customer-view',
      children: [
        {
          id: 2.11,
          text: 'Dashboard',
          path: '/dashboard',
          icon: <DashboardOutlinedIcon />,
          permission: '',
          visibility: true,
          type: 'customer-view'
        },
        {
          id: 2.2, text: 'User Management', path: '/user-management', icon: <PeopleOutlinedIcon />, permission: "dashboard-read", visibility: [...Object.values(permissionConfig?.partner || {}), ...Object.values(permissionConfig?.customer || {}), ...Object.values(permissionConfig?.user || {})].some(Boolean), type: 'customer-view',
          children: [

            {
              id: 2.13,
              text: 'Users',
              path: '/user-management/users/6789',
              icon: <GroupOutlinedIcon width="22px" height="22px" />,
              permission: "user-read",
              visibility: permissionConfig?.user.create || permissionConfig?.user.read || permissionConfig?.user.update,
              type: 'customer-view'

            },
            {
              id: 2.14,
              text: 'Teams',
              path: '/user-management/teams',
              icon: <Diversity3OutlinedIcon width="22px" height="22px" />,
              permission: "user-read",
              visibility: permissionConfig?.team.create || permissionConfig?.team.read || permissionConfig?.team.update,
              type: 'customer-view'

            },
          ],
        },
        {
          id: 2.3, text: 'Insights', path: '/insight', icon: <ReportIcon />, permission: "reports-read", visibility: userPermissions?.includes('customer_report_templates_list') || userPermissions?.includes('report_history_list'), type: 'customer-view',
          children: [
            {
              id: 2.31,
              text: 'Report Template',
              path: '/report-templates',
              icon: <ViewModuleIcon width="22px" height="22px" />,
              permission: "reports-read",
              visibility: userPermissions?.includes('customer_report_templates_list'),
              type: 'customer-view'


            },
            {
              id: 2.32,
              text: 'Report History',
              path: '/report-history',
              icon: <HistoryIcon width="22px" height="22px" />,
              permission: "reports-read",
              visibility: userPermissions?.includes('report_history_list'),
              type: 'customer-view'

            },
            {
              id: 2.33,
              text: 'Report Dashboard',
              path: '/report-dashboard',
              icon: <GridViewIcon width="22px" height="22px" />,
              permission: "reports-read",
              visibility: userPermissions?.includes('report_history_list'),
              type: 'customer-view'
            }
          ]
        },
        {
          id: 2.4, text: 'Logs', path: '/logs/ef35710f', icon: <BusinessCenterOutlinedIcon />, permission: '', visibility: userPermissions?.includes('customer_workflow-update'), type: 'customer-view'
        },
        {
          id: 2.5, text: 'Event Pro', path: '/event-pro', icon: <EventOutlinedIcon />, permission: '', visibility: permissionConfig?.basic.read, type: 'customer-view',
          children: [
            {
              id: 2.53451,
              text: 'Calendars',
              path: '/event-pro/calendar',
              icon: <CalendarMonthOutlinedIcon width="22px" height="22px" />,
              permission: "reports-read",
              visibility: true,
              type: 'customer-view'

            },
            {
              id: 2.232452,
              text: 'Schedules',
              path: '/event-pro/schedule',
              icon: < ScheduleOutlinedIcon width="22px" height="22px" />,
              permission: "reports-read",
              visibility: true,
              type: 'customer-view'

            }
          ]
        },
        {
          id: 2.6, text: 'Templates', path: '/my-templates', icon: <ViewCompactAltOutlinedIcon />, permission: '', visibility: userPermissions?.includes('customer_workflow-update'), type: 'customer-view'
        },
        // {
        //   id: 2.7, text: 'Profile', path: '/profile', icon: <Person2OutlinedIcon />, permission: '', visibility: false, type: 'customer-view'
        // },
        { id: 2.7, text: 'Connections', path: '/connections', icon: <VpnLockIcon />, permission: '', visibility: userPermissions?.includes('trigger-workflow'), type: 'customer-view' },
        {
          id: 2.8, text: 'Inbox', path: '/inbox', icon: <InboxOutlinedIcon />, permission: '', visibility: false, type: 'customer-view'
        },
        {
          id: 2.9, text: 'Settings', path: '/settings/1c4367ee2', icon: <SettingsOutlinedIcon />, permission: '', visibility: userPermissions?.includes('client_settings_detail') || userPermissions?.includes('client_settings_update') || userPermissions?.includes('client_settings_create'), type: 'customer-view'
        },
      ]
    },

  ]
}
export const defaultDashboardMenu = (permissionConfig, userType, partnerCustomer, userPermissions) => {


  return [

    {
      id: 1.1,
      text: 'Dashboard',
      path: '/dashboard',
      icon: <DashboardOutlinedIcon />,
      permission: '',
      visibility: true,
    },
    {
      id: 1.2, text: 'User Management', path: '/user-management', icon: <PeopleOutlinedIcon />, permission: "dashboard-read", visibility: [...Object.values(permissionConfig?.partner || {}), ...Object.values(permissionConfig?.customer || {}), ...Object.values(permissionConfig?.user || {})].some(Boolean),
      children: [
        {
          id: 1.11,
          text: 'Partner',
          path: '/user-management/partner',
          icon: <PartnerIcon width="22px" height="22px" />,
          permission: "partner-read",
          visibility: permissionConfig?.partner?.create || permissionConfig?.partner?.read || permissionConfig?.partner?.update,
        },
        {
          id: 1.12,
          text: 'Customer',
          path: '/user-management/customer',
          icon: <HeadsetMicOutlinedIcon width="22px" height="22px" />,
          permission: "customer-read",
          visibility: permissionConfig?.customer.create || permissionConfig?.customer.read || permissionConfig?.customer.update,
        },
        {
          id: 1.13,
          text: 'Users',
          path: '/user-management/users',
          icon: <GroupOutlinedIcon width="22px" height="22px" />,
          permission: "user-read",
          visibility: permissionConfig?.user.create || permissionConfig?.user.read || permissionConfig?.user.update,
        },
      ],
    },
    {
      id: 1.3, text: 'Insights', path: '/insight', icon: <ReportIcon />, permission: "reports-read", visibility: userPermissions?.includes('customer_report_templates_list') || userPermissions?.includes('report_history_list'),
      children: [
        {
          id: 1.31,
          text: 'Report Template',
          path: '/report-templates',
          icon: <ViewModuleIcon width="22px" height="22px" />,
          permission: "reports-read",
          visibility: userPermissions?.includes('customer_report_templates_list')
        },
        {
          id: 1.32,
          text: 'Report History',
          path: '/report-history',
          icon: <HistoryIcon width="22px" height="22px" />,
          permission: "reports-read",
          visibility: userPermissions?.includes('report_history_list')
        },
        {
          id: 1.33,
          text: 'Report Dashboard',
          path: '/report-dashboard',
          icon: <GridViewIcon width="22px" height="22px" />,
          permission: "reports-read",
          visibility: userPermissions?.includes('report_history_list'),
          type: 'customer-view'
        }
      ]
    },
    { id: 1.4, text: 'Logs', path: '/logs', icon: <BusinessCenterOutlinedIcon />, permission: '', visibility: userPermissions?.includes('customer_workflow-update') },
    {
      id: 1.5, text: 'Event Pro', path: '/event-pro', icon: <EventOutlinedIcon />, permission: '', visibility: permissionConfig?.basic.read,
      children: [
        {
          id: 1.51,
          text: 'Calendars',
          path: '/event-pro/calendar',
          icon: <CalendarMonthOutlinedIcon width="22px" height="22px" />,
          permission: "reports-read",
          visibility: true
        },
        {
          id: 1.52,
          text: 'Schedules',
          path: '/event-pro/schedule',
          icon: < ScheduleOutlinedIcon width="22px" height="22px" />,
          permission: "reports-read",
          visibility: true
        }
      ]
    },
    { id: 1.6, text: 'Templates', path: '/my-templates', icon: <ViewCompactAltOutlinedIcon />, permission: '', visibility: userPermissions?.includes('customer_workflow-update') },
    { id: 1.7, text: 'Profile', path: '/profile', icon: <Person2OutlinedIcon />, permission: '', visibility: userPermissions?.includes('user-detail-read') },
    { id: 3.1, text: 'Connections', path: '/connections', icon: <VpnLockIcon />, permission: '', visibility: userPermissions?.includes('trigger-workflow') },
    { id: 1.8, text: 'Inbox', path: '/inbox', icon: <InboxOutlinedIcon />, permission: '', visibility: true },
    // { id: 1.9, text: 'Settings', path: '/settings', icon: <SettingsOutlinedIcon />, permission: '', visibility: true },
  ]
}

export const customerDashboardMenu = (permissionConfig, userType, partnerCustomer, userPermissions) => {
  return [

    {
      id: 1.1,
      text: 'Dashboard',
      path: '/dashboard',
      icon: <DashboardOutlinedIcon />,
      permission: '',
      visibility: true,
    },
    {
      id: 1.2, text: 'User Management', path: '/user-management', icon: <PeopleOutlinedIcon />, permission: "dashboard-read", visibility: [...Object.values(permissionConfig?.partner || {}), ...Object.values(permissionConfig?.customer || {}), ...Object.values(permissionConfig?.user || {})].some(Boolean),
      children: [
        {
          id: 1.11,
          text: 'Partner',
          path: '/user-management/partner',
          icon: <PartnerIcon width="22px" height="22px" />,
          permission: "partner-read",
          visibility: permissionConfig?.partner?.create || permissionConfig?.partner?.read || permissionConfig?.partner?.update,
        },
        {
          id: 1.12,
          text: 'Customer',
          path: '/user-management/customer',
          icon: <HeadsetMicOutlinedIcon width="22px" height="22px" />,
          permission: "customer-read",
          visibility: permissionConfig?.customer.create || permissionConfig?.customer.read || permissionConfig?.customer.update,
        },
        {
          id: 1.13,
          text: 'Users',
          path: '/user-management/users',
          icon: <GroupOutlinedIcon width="22px" height="22px" />,
          permission: "user-read",
          visibility: permissionConfig?.user.create || permissionConfig?.user.read || permissionConfig?.user.update,
        },
        {
          id: 1.14,
          text: 'Teams',
          path: '/user-management/teams',
          icon: <Diversity3OutlinedIcon width="22px" height="22px" />,
          permission: "user-read",
          visibility: permissionConfig?.team.create || permissionConfig?.team.read || permissionConfig?.team.update,
        },
      ],
    },
    {
      id: 1.3, text: 'Insights', path: '/insight', icon: <ReportIcon />, permission: "reports-read", visibility: userPermissions?.includes('customer_report_templates_list') || userPermissions?.includes('report_history_list'),
      children: [
        {
          id: 1.31,
          text: 'Report Template',
          path: '/report-templates',
          icon: <ViewModuleIcon width="22px" height="22px" />,
          permission: "reports-read",
          visibility: userPermissions?.includes('customer_report_templates_list')
        },
        {
          id: 1.32,
          text: 'Report History',
          path: '/report-history',
          icon: <HistoryIcon width="22px" height="22px" />,
          permission: "reports-read",
          visibility: userPermissions?.includes('report_history_list')
        },
        {
          id: 1.33,
          text: 'Report Dashboard',
          path: '/report-dashboard',
          icon: <GridViewIcon width="22px" height="22px" />,
          permission: "reports-read",
          visibility: userPermissions?.includes('report_history_list'),
          type: 'customer-view'
        }
      ]
    },
    { id: 1.4, text: 'Logs', path: '/logs', icon: <BusinessCenterOutlinedIcon />, permission: '', visibility: userPermissions?.includes('customer_workflow-update') },
    {
      id: 1.5, text: 'Event Pro', path: '/event-pro', icon: <EventOutlinedIcon />, permission: '', visibility: permissionConfig?.basic.read,
      children: [
        {
          id: 1.51,
          text: 'Calendars',
          path: '/event-pro/calendar',
          icon: <CalendarMonthOutlinedIcon width="22px" height="22px" />,
          permission: "reports-read",
          visibility: true
        },
        {
          id: 1.52,
          text: 'Schedules',
          path: '/event-pro/schedule',
          icon: < ScheduleOutlinedIcon width="22px" height="22px" />,
          permission: "reports-read",
          visibility: true
        }
      ]
    },
    { id: 1.6, text: 'Templates', path: '/my-templates', icon: <ViewCompactAltOutlinedIcon />, permission: '', visibility: userPermissions?.includes('customer_workflow-update') },
    { id: 1.7, text: 'Profile', path: '/profile', icon: <Person2OutlinedIcon />, permission: '', visibility: userPermissions?.includes('user-detail-read') },
    { id: 3.1, text: 'Connections', path: '/connections', icon: <VpnLockIcon />, permission: '', visibility: userPermissions?.includes('trigger-workflow') },
    { id: 1.8, text: 'Inbox', path: '/inbox', icon: <InboxOutlinedIcon />, permission: '', visibility: true },
    // { id: 1.9, text: 'Settings', path: '/settings', icon: <SettingsOutlinedIcon />, permission: '', visibility: true },
  ]
}